import { useEffect, useState } from "react";
import { AppContext } from "./AppContext";

import "./App.css";
import Background from "./Components/Background/Background";
import Application from "./Components/Application/Application";
import MatrixLogo from "../src/assets/MatrixLogo.png";
import { useNavigate } from "react-router-dom";
import { appVersion } from "./appVersion";

function App() {
  const initialPath = window.location.pathname;
  const navigate = useNavigate();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [path, setPath] = useState(initialPath);
  const [headerLogo, setHeaderLogo] = useState(MatrixLogo);
  const [matrixData, setMatrixData] = useState([
    {
      Request: "No Request",
    },
  ]);
  const [modal, setModal] = useState("inactive");
  const [preapprovalModal, setPreapprovalModal] = useState("inactive");
  const [loginModalInputs, setLoginModalInputs] = useState([
    ["inputOneId", "inputOneText"],
    ["inputTwoId", "inputTwoText"],
  ]);
  const [loginModalAction, setLoginModalAction] = useState("");
  const [userType, setUserType] = useState("");
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [userTeam, setUserTeam] = useState("");
  const [fubId, setFubId] = useState(0);
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [userCompanyId, setUserCompanyId] = useState("");
  const [generatePreApprovalModal, setGeneratePreApprovalModal] = useState({
    status: "inactive",
    propertyAddress: "",
    clientName: "",
    preApprovalAmount: 0,
    loanOfficerName: "",
    loanOfficerEmail: "",
    agentPartner: "",
    agentEmail: "",
    downpaymentPercentage: 0,
    loanProgram: "",
    googleTemplateID: "",
    googleFolderId: "",
  });
  const [underContractModal, setUnderContractModal] = useState({
    status: "inactive",
    propertyAddress: "",
    clientName: "",
    preApprovalAmount: 0,
    loanOfficerName: "",
    loanOfficerEmail: "",
    agentPartner: "",
    agentEmail: "",
    downpaymentPercentage: 0,
  });

  const [buyersGuide, setBuyersGuide] = useState(null);
  const [buyersGuideEditable, setBuyersGuideEditable] = useState(null);
  const [workshopMaterials, setWorkshopMaterials] = useState("fullScreen down");
  const [navbar, setNavbar] = useState("nav-bar down");
  const [midbar, setMidbar] = useState("extended");
  const [clientSelection, setClientSelection] = useState("Pre Approved");
  const [preApprovedListModalVisible, setPreApprovedListModalVisible] =
    useState("hidden");
  const [uCCListModalVisible, setUCCListModalVisible] = useState("hidden");
  const [appMode, setAppMode] = useState("on");
  const [textNotifications, setTextNotifications] = useState(false);
  const [inputPreApprovalNames, setInputPreApprovalNames] = useState("");
  const [ucPanelsController, setUcPanelsController] = useState([]);
  const [preApprovalPanelsController, setPreApprovalPanelsController] =
    useState([]);
  const [pendingPanelsController, setPendingPanelsController] = useState([]);
  const [teamFilter, setTeamFilter] = useState("hidden");
  const [loFilter, setLoFilter] = useState("hidden");
  const [loPreapprovedFilter, setLoPreapprovedFilter] = useState("hidden");
  const [pendingClientFilter, setPendingClientFilter] = useState("hidden");
  const [preapprovedClientFilter, setPreapprovedClientFilter] =
    useState("hidden");
  const [agentFilter, setAgentFilter] = useState("hidden");
  const [agentPreapprovedFilter, setAgentPreapprovedFilter] =
    useState("hidden");
  const [teamMemberSelected, setTeamMemberSelected] = useState("");
  const [teamMemberSelectedInfo, setTeamMemberSelectedInfo] = useState("");
  const [teamPermissions, setTeamPermissions] = useState(false);
  const [teamOptions, setTeamOptions] = useState(null);
  const [teamArray, setTeamArray] = useState([
    { Id: null, Name: "Loading team..." },
  ]);

  const [pendingClientCount, setPendingClientCount] = useState(0);
  const [preapprovedClientCount, setPreapprovedClientCount] = useState(0);
  const [transactionsUnderContractCount, setTransactionsUnderContractCount] =
    useState(0);

  //Keys & Environment Variables

  const [makeKey, setMakeKey] = useState("");
  const [fubKey, setFubKey] = useState("");
  const [movePassword, setMovePassword] = useState("");
  useEffect(() => {
    const apiKeyUrl = `/.netlify/functions/getMakeKey`;
    fetch(apiKeyUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        setMakeKey(body.makeKey);
      });

    const movePasswordUrl = `/.netlify/functions/getMovePassword`;
    fetch(movePasswordUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        setMovePassword(body.movePassword);
      });
  }, []);

  useEffect(() => {
    setPendingClientCount(
      matrixData[0].Request === "No Request"
        ? null
        : JSON.parse(matrixData[0]["Clients"]).filter((e) => {
            return (
              e.MtgPlanner_CRM__Stage__c === "New Lead" ||
              e.MtgPlanner_CRM__Stage__c === "Attempting Contact" ||
              e.MtgPlanner_CRM__Stage__c === "Appointment Scheduled" ||
              e.MtgPlanner_CRM__Stage__c === "Application Sent" ||
              e.MtgPlanner_CRM__Stage__c === "Docs Requested" ||
              e.MtgPlanner_CRM__Stage__c === "Docs Received"
            );
          }).length
    );
    setPreapprovedClientCount(
      matrixData[0].Request === "No Request"
        ? null
        : JSON.parse(matrixData[0]["Clients"]).filter((e) => {
            return e.MtgPlanner_CRM__Stage__c === "Pre-Approved";
          }).length
    );
    const transactionsUnderContractData =
      matrixData[0].Request === "No Request"
        ? null
        : JSON.parse(matrixData[0]["UnderContract"]).filter(
            (e) =>
              e.MtgPlanner_CRM__Status__c === "Under Contract" ||
              e.MtgPlanner_CRM__Status__c === "Registered" ||
              e.MtgPlanner_CRM__Status__c === "Submitted" ||
              e.MtgPlanner_CRM__Status__c === "Suspended" ||
              e.MtgPlanner_CRM__Status__c === "Conditionally Approved" ||
              e.MtgPlanner_CRM__Status__c === "Clear to Close" ||
              e.MtgPlanner_CRM__Status__c === "Docs Out" ||
              e.MtgPlanner_CRM__Status__c === "Closed"
          );
    setTransactionsUnderContractCount(
      matrixData[0].Request === "No Request"
        ? null
        : transactionsUnderContractData.length
    );
  }, [matrixData]);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
    window.addEventListener("orientationchange", handleResize, false);
  }, []);

  return (
    <div className="App">
      <AppContext.Provider
        value={{
          appVersion,
          path,
          setPath,
          windowWidth,
          setWindowWidth,
          headerLogo,
          setHeaderLogo,
          matrixData,
          setMatrixData,
          modal,
          setModal,
          preapprovalModal,
          setPreapprovalModal,
          loginModalInputs,
          setLoginModalInputs,
          loginModalAction,
          setLoginModalAction,
          userType,
          setUserType,
          userId,
          setUserId,
          userName,
          setUserName,
          fubId,
          setFubId,
          fubKey,
          setFubKey,
          userEmail,
          setUserEmail,
          userPhone,
          setUserPhone,
          userPassword,
          setUserPassword,
          generatePreApprovalModal,
          setGeneratePreApprovalModal,
          underContractModal,
          setUnderContractModal,
          userCompany,
          setUserCompany,
          userCompanyId,
          setUserCompanyId,
          makeKey,
          setMakeKey,
          movePassword,
          workshopMaterials,
          setWorkshopMaterials,
          navbar,
          setNavbar,
          clientSelection,
          setClientSelection,
          preApprovedListModalVisible,
          setPreApprovedListModalVisible,
          uCCListModalVisible,
          setUCCListModalVisible,
          appMode,
          setAppMode,
          textNotifications,
          setTextNotifications,
          midbar,
          setMidbar,
          inputPreApprovalNames,
          setInputPreApprovalNames,
          ucPanelsController,
          setUcPanelsController,
          preApprovalPanelsController,
          setPreApprovalPanelsController,
          pendingPanelsController,
          setPendingPanelsController,
          teamFilter,
          setTeamFilter,
          loFilter,
          setLoFilter,
          pendingClientFilter,
          setPendingClientFilter,
          agentFilter,
          setAgentFilter,
          preapprovedClientFilter,
          setPreapprovedClientFilter,
          loPreapprovedFilter,
          setLoPreapprovedFilter,
          agentPreapprovedFilter,
          setAgentPreapprovedFilter,
          navigate,
          teamMemberSelected,
          setTeamMemberSelected,
          teamMemberSelectedInfo,
          setTeamMemberSelectedInfo,
          userTeam,
          setUserTeam,
          fubKey,
          pendingClientCount,
          setPendingClientCount,
          preapprovedClientCount,
          setPreapprovedClientCount,
          transactionsUnderContractCount,
          setTransactionsUnderContractCount,
          teamPermissions,
          setTeamPermissions,
          teamOptions,
          setTeamOptions,
          teamArray,
          setTeamArray,
          buyersGuide,
          setBuyersGuide,
          buyersGuideEditable,
          setBuyersGuideEditable,
        }}
      >
        <Background />
        <Application />
      </AppContext.Provider>
    </div>
  );
}

export default App;
